export default {
    txt_welcome: 'Bem-vindo',
    txt_dataover: 'Visão geral de dados',
    txt_chance: 'Oportunidade',
    txt_device: 'Dispositivo',
    txt_chinese: '中文-Chinese',
    txt_english: '英文-English',
    txt_malay: '马来语-Malay',
    txt_reports: 'História',
    txt_setting: 'Ambiente',
    txt_dymanager: 'Gestão de pessoal na loja',
    txt_account: 'Conta',
    txt_userstatus: 'Identificação',
    txt_name: 'Nome',
    txt_contactway: 'Contatos',
    txt_accountsafe: 'Segurança da conta',
    txt_basicinfo: 'Informação básica',
    txt_updatepassword: 'Modificar senha',
    txt_storeinfomation: 'Informação da loja',
    txt_storename: 'Nome da loja',
    txt_storephone: 'TEL da loja',
    txt_storeaddress: 'Endereço da loja',
    txt_AppInfomation: 'Informações do aplicativo',
    txt_currentversion: 'Versão No.',
    txt_software: 'Atualização do software',
    txt_loginout: 'Logout',
    txt_updatelanguage: 'Idioma',
    txt_updateto: 'Atualizado para',
    txt_zwgx: 'Sem atualização',
    txt_dz: 'Gerente da loja',
    txt_sh: 'Comerciante',
    txt_dy: 'Pessoal',
    txt_bdsj: 'Vincular com telemóvel',
    txt_shxx: 'Informação da empersa',
    txt_shname: 'Nome do comerciante',
    txt_ssmd: 'Nome da loja',
    txt_bdsb: 'Vincular dispositivo',
    txt_mendian: 'Loja',


    //数据总览模块
    txt_sTime: 'Selecionar período',
    txt_car_check: 'Taxa de inspeção de veículos',
    txt_findchance: 'Encontrar oportunidades',
    txt_trackchace: 'Rastreamento de oportunidades',
    txt_transform: 'Taxas de conversão',
    txt_TotalData: 'Visão geral',
    txt_xxsj: 'Dados detalhados',
    txt_zhsj: 'Dados de conversão',
    txt_TireWear: 'Desgaste dos pneus',
    txt_DataHopper: 'Funil',
    txt_jdcc: 'Número de veículos que entram na loja',
    txt_CheckCar: 'Número de veículos inspecionados',
    txt_ChanceNum: "Vendas lideram Q'ty",
    txt_TrackNum: 'Número de rastreamentos',
    txt_TranseformNum: 'Número de conversões',
    txt_UnTrack: 'Não rastreado',
    txt_l: 'Um (unidade)',
    txt_Time: 'Tempo',
    txt_Device: 'Dispositivo',
    txt_car_plate: 'Placa',
    txt_Wear: 'Desgaste',
    txt_Pwear: 'Desgaste excêntrico',
    txt_NoData: 'Sem dados',
    txt_GoodState: 'Estado bom',
    txt_Border: 'Estao limite',
    txt_replace: 'Substitui agora',
    txt_Total_Check: 'Total',
    txt_pmqk: 'Estado de desgaste excêntrico',
    txt_LightWear: 'Desgaste excêntrico leve',
    txt_GraveWear: 'Desgaste excêntrico grave',
    txt_hwtj: 'Rotação',
    txt_wxhw: 'Não precisa e de mudar de posição',
    txt_xyhw: 'Precisa e de mudar de posição',
    txt_jcxq: 'Detalhes',
    txt_zhxq: 'Detalhes de conversão',
    txt_cc: 'Veículos',
    txt_bfb: '%',
    txt_ltxs: 'Venda de pneus',
    txt_sldw: 'Alinhador de quatro rodas',
    txt_ddlph: 'Equilíbrio',
    txt_dphhh: 'equilíbrio dinâmico',
    txt_qt: 'Outros ',
    txt_zhqs: 'Tendência de conversão',
    txt_ltxl: "Vendas de pneus Q'ty",
    txt_ltfw: 'Serviço de pneu',
    txt_ckxq: 'Detalhes',
    txt_jt: 'Hoje',
    txt_zt: 'Ontem',
    txt_bz: 'Nesta semana',
    txt_by: 'Neste mês',
    txt_sy: 'Mês anterior',
    txt_jn: 'Neste ano',
    txt_zhcl: 'Veículo de conversão',
    txt_zhl: 'Taxas de conversão',
    txt_bfb: '%',
    txt_abjx: 'Distribuição do número de pneus sob condições de limite',
    txt_aljg: 'Substitua imediatamente a distribuição do número de pneus',
    txt_qwpm: 'Distribuição de depuração de pneus sob desgaste excêntrico leve',
    txt_ayzp: 'Distribuição do número de pneus sob desgaste excêntrico grave',
    txt_lingt: '0 pneu',
    txt_yt: '1 pneu',
    txt_et: '2 pneus',
    txt_st: '3 pneus',
    txt_ft: '4 pneus',

    //机会
    txt_xsjh: 'Oportunidade',
    txt_gzz: 'No rastreamento',
    txt_clwb: 'Tratamento concluído',
    txt_ckbg: 'Detalhes do relatório',
    txt_yxs: 'Exibe todos os dados',
    txt_zhuiz: 'No rastreamento',
    txt_tix: 'Lembrete de rastreamento',
    txt_chuli: 'Tratamento',
    txt_yzh: 'Tratamento',
    txt_wzh: 'Convertido',
    txt_gzsmts: 'Verificou problemas em {} Espere vir à loja para verificar em {}',
    txt_czbty: 'O dono discorda',
    txt_yyx: 'Tem a intenção',
    txt_ltyg: '1 pneu',
    txt_ltkg: '2 pneus',
    txt_ltsang: '3 pneus',
    txt_ltsig: '4 pneus',
    txt_jhcl: 'Tratamento de oportunidade',
    txt_jhztai: 'Estado de oportunidade',
    txt_crquy: 'Área',
    txt_chuliry: 'Pessoal de tratamento',
    txt_chulijg: 'Fechado',
    txt_zhuanhuanr: 'Contenúdo de conversão',
    txt_zhuanhuaje: 'Valor de conversão',
    txt_zhuanhuasj: 'Tempo de conversão',
    txt_zhuanhuayx: 'Intenção',
    txt_xuanzesj: 'Escolhe hora',
    txt_tsdatawk: 'O estado da oportunidade está vazio e os dados não podem ser salvos',
    txt_qtxzhsj: 'Preencha o tempo de conversão esperado',
    txt_qtxzhnr: 'Preencha conteúdo de conversão',
    txt_qtxzhsj: 'Preencha tempo de conversão',
    txt_sbts: 'Falha ao salvar dados, verifique a rede',


    //设备
    txt_sbgl: 'Equipamentos de detecção',
    txt_tj: 'Adicionar',
    txt_gdssb: '{}dispositivos em total',
    txt_sbbh: 'Dispositivo No.',
    txt_gjbb: 'Versão de hardware',
    txt_tjsj: 'Adiconar tempo',
    txt_zdgx: 'Atualizar automaticamente',
    txt_gxgj: 'atualização de hardware',
    txt_jieb: 'Desvincluar',
    txt_sbtsxx: 'Dispositivo tem atualizações, clique para atualizar',
    txt_wjh: '未激活',
    txt_lix: 'Offline',
    txt_zaix: 'Online',
    txt_guz: 'Falta',
    txt_yijieb: 'Desvinculado',
    txt_yihuis: 'Recuperado',
    txt_gxsbgj: 'Dispositivo de atualização',
    txt_gxsbgjts: 'Deseja atualizar o dispositivo?',
    txt_socketdk: 'A conexão de comunicação com o servidor não foi estabelecida, tente novamente',
    txt_cscgts: 'Pedido de atualização de hardware enviado com sucesso',
    txt_jbsb: 'Dispositivo desvinculado',
    txt_jbsbts: 'Você quer desvincular o dispositivo.',
    txt_tscg: 'Com sucesso',
    txt_zdgxgj: 'Atualização',
    txt_gxgjts: 'Tem certeza de que deseja ativar/desativar a função de atualização automática do firmware?',
    txt_beiz: 'Observações',
    txt_qtxbz: 'Preencha OBS.',
    txt_bdsbts: 'Este APP é usado apenas para o dispositivo de [Detecção de Pneus Portátil Versão Internacional], certifique-se de que o modelo do dispositivo que você deseja vincular está correto',
    txt_qdksb: 'Ligue o dispositivo primeiro',
    txt_dksbts1: 'Nova dispositivo, entrar na guia de vinculação automaticamente depois de ligar',
    txt_dksbts2: 'Se o dispositivo foi vinculado a outra loja antes, clique em Desvincular dispositivo no menu "Configurações" do dispositivo para desvinculá-lo. Após desvincular, o dispositivo entrará automaticamente no guia de vinculação',
    txt_yjdksblw: 'Ligei o dispositivo e concete-se à rede',
    txt_xyb: 'Próximo passo',
    txt_qsclj: 'Escaneie o código QR',
    txt_qscts1: 'Se a operação de varredura for bem-feita, o dispositivo emite um bipe.',
    txt_qscts2: 'Digitalizado com sucesso',
    txt_sbtssmcg: 'Digitalizado com sucesso',
    txt_ddsblw: 'Espere o dispositivo conectar à rede',
    txt_zznlbd: 'Por favor, esperando',
    txt_qszdd: 'Demora dezenas de segundos, espere',
    txt_bdcg: 'Dispositivo vinculado com sucesso',
    txt_tjcg: 'Adicionado com sucesso',
    txt_tjcgts: 'Adicionado com sucesso, preencha o nome do comentário para ajudá-lo a identificar o dispositivo',
    txt_fhsblb: 'Voltar à lista de dispositivos',
    txt_jxtjsb: 'Continue a adicionar',
    txt_bzmc: 'Dispositivo de observação',


    //检测记录
    txt_sx: 'Filtrar',
    txt_khsj: 'Telemóvel do cliente',
    txt_cphm: 'Número Da placa',
    txt_cphm1: 'Número Da Placa de matrícula',
    txt_clxh: 'modelo de veículo',
    txt_xgbz: 'Modificar ',
    txt_gtfjl: 'Total {0} ',
    txt_jcsj: 'Tempo de detecção',
    txt_jcsj1: 'Tempo de detecção',
    txt_xzkssj: 'Escolhe a hora de início',
    txt_xzjssj: 'Escolhe a hora de término',
    txt_jcjg: 'Resultado de detecção',
    txt_msqk: 'condição de desgaste',
    txt_jygh: 'substituição recomendada',
    txt_zysh: 'Preste atenção Na perda',
    txt_zcsy: 'Utilização normal',
    txt_zc: 'Normal',
    txt_cz: 'Redefinir',
    txt_qd: 'OK',
    txt_jcjgd: 'Resultado de detecção',
    txt_msqkd: 'Desgaste',
    txt_sldwd: 'Alinhador de quatro rodas',
    txt_jyghd: 'Substituir',
    txt_zysh: 'Fronteira',
    txt_zcsyd: 'Normal',
    txt_xdwd: 'O alinhamento é necessário',
    txt_xzyd: 'Atenção',
    txt_zcd: 'Normal',
    txt_bgxq: 'Detalhes do relatório',
    txt_ljdy: '连接打印',
    txt_fwmd: 'Loja de serviços',
    txt_mddz: 'Endereço da loja',
    txt_jcsb: 'Equipamentos de detecção',
    txt_ddmd: 'Destino na loja',
    txt_lic: 'Quilometragem de veículo',
    txt_chex: 'Modelo de veículo',
    txt_jcjyi: 'Recomendação sobre detecção',
    txt_ysbs: 'Identificação de cores',
    txt_ztms: 'Desgaste geral',
    txt_hwms: 'Estado de desgaste Ecêntrico',
    txt_dqscjltx: 'Lembrete de distância de frenagem atual',
    txt_bgxqts: ' 备注：该测试由独立测试中心天津汽车检测中心进行，所用车辆为奥迪品牌FV7203BECGB型乘用车，轮胎规格为：245/40 R18,轮胎充气压力为：前胎230kpa，后胎220kpa；测试场地为：卡达克盐城测试地；所计算的车辆制动距离的速度范围:从100公里/小时减速至0公里/小时。',
    txt_wxsmgz: '微信扫码关注 TyreHub 公众号',
    txt_hwmsjh: 'Desgaste uniforme do padrão',
    txt_zqlun: 'Roda dianteira esquerda',
    txt_zhlun: 'Roda traseira esquerda',
    txt_yqlun: 'Roda dianteira direita',
    txt_yhlun: 'Roda traseira direita',
    txt_pingjunzhi: 'Valor médio:',
    txt_guige: 'Especificação ',
    txt_gongli: 'Quilómetro',
    txt_ltwjc: 'Pneus não detectados',
    txt_pinpai: 'Marca',
    txt_ltws: 'Aparência dos pneus',
    txt_sewmts: 'Digitalizar código QR\nVer relatório', 
    txt_print: 'Print',





    //店员管理
    txt_xz: 'Adicionar',
    txt_qy: 'Ativar',
    txt_qyz: 'Trabalhando',
    txt_ty: 'Desativar',
    txt_yhzh: 'Foi bloqueado',
    txt_lxfs: 'Contatos',
    txt_cjsj: 'Tempo de criação',
    txt_bjxx: 'Editar informação',
    txt_xgmm: 'Modificar senha',
    txt_bgzt: 'Alterar estado',
    txt_qdytjm: 'Tem certeza que deseja desativar/ativar conta XX？',
    txt_tjdy: 'Adicionar funcionário',
    txt_bjdyxx: 'Editar informações dos funcionários',
    txt_zhxx: 'Conta info',
    txt_ygxm: 'Nome de funcionário',
    txt_qtxygxm: 'Preencha o nome de funcionário',
    txt_lxdh: 'Informações de contato',
    txt_qtxyglxdh: 'Peencha telemóvel',
    txt_dxyzm: 'Código de verificação por SMS',
    txt_qtxdxyzm: 'Preencha o código de verificação por SMS',
    txt_fsdx: 'Enviar SMS',
    txt_tjzh: 'Adicionar conta',
    txt_baocun: 'Salvar',
    txt_gtgygzh: '{}contas de funcionários em total',



    //登录
    txt_qdytcdlm: 'Pronto para logout ',
    txt_qx: 'Cancelar',
    txt_dl: 'Login',
    txt_qsrzh: 'Por favor, digite o ID da conta',
    txt_qsrmm: 'Digite a senha',
    txt_zcshzh: 'Registre-se para comerciante',
    txt_shzhwjmm: 'Esqueci passowrd',
    txt_yzdqmm: 'Verificar senha atual',
    txt_szxmm: 'Definer senha nova',
    txt_xgcg: 'Modificado com sucesso',
    txt_qtxjmm: 'Preencha senha antiga',
    txt_yzzcsj: 'Verificar e registrar telemóvel',
    txt_qtxxmm: 'Defina nova senha',
    txt_qzctxxmm: 'Digite a senha novamente',
    txt_lcmmsrbyz: 'As duas senhas são inconsistentes',
    txt_gxnxgcg: 'Parabéns, a nova senha foi modificada com sucesso',
    txt_qljndxmm: 'Por favor, lembre-se de sua nova senha',
    txt_fhgrzx: 'Voltar',
    txt_fsyzm: 'Enviar código de verificação',
    txt_qtxzcsjh: 'Preencha número de telemóvel registrado',
    txt_qtxtxyzm: 'Por favor, preencha o código gráfico',
    txt_qsryzm: 'Digite código de verificação',
    txt_qszhhmm: 'Defina uma senha com pelo menos 6 dígitos',
    txt_qzcsrmm: 'Por favor, repita a senha',
    txt_lcmmbyz: 'As duas senhas são inconsistentes',
    txt_hdsy: 'Voltar à página principal',
    txt_zcshh: 'Registre-se para comerciante',
    txt_fhdl: 'De volta à página de login',
    txt_wlqqsb: 'Internet anormal, por favor, tente novamente',
    txt_wczc: 'Registro concluído',
    txt_wsts: ' Completer info da empersa',
    txt_qtxshmc: 'Digite nome do comerciante (nome da empersa)',
    txt_shmc: 'Nome do comerciante',
    txt_rgszjd: 'Como telefone fixo do comerciante, outro telefone, fax e etc',
    txt_qtlxfs: 'Outros contatos',
    txt_kssy: 'Comece a usar',
    txt_Pwear1: 'Desgaste excêntrico',
    txt_open: 'Abrir',
    txt_close: 'Fechar',
    txt_srczhdmm: 'Preencha a nova senha',
    txt_kcfs: '{0}s',
    txt_xiugai: 'Modificar',
    txt_zzjzsj: 'Carregamento',
    txt_bjshxx: 'Editar informações do comerciante',
    txt_chongxinhq: 'Re-enviar',
    txt_gaibangsj: 'Modificar o celular',
    txt_yanzhengjsj: 'Verifique o celular antigo',
    txt_bangdingxsj: 'Ligue-se ao novo celular',
    txt_yhqsyxsjdl: 'Faça login por telefone novo',



    //登录新
    txt_xzshenfen: 'Por favor, selecione seu papel',
    txt_dlrolewz: 'Login No.{}',
    txt_qsrsjh: 'Digite número de telemóvel',
    txt_zhuce: 'Registrar',
    txt_wanjimima: 'Esqueceu a senha',
    txt_wanshandzxx: 'Completer info da conta de gerente',
    txt_qsrxm: 'Por favor, digite seu nome',
    txt_qsrmdm: 'Digite nome da loja',
    txt_qsrmdgddh: 'Digite tel fixo da loja',
    txt_qsrmddz: 'Digite endereço da loja',
    txt_qsrgsdz: 'Digite endereço da empresae',
    txt_qsrxxdz: 'Digite endereço detalhe',
    txt_tijiaocg: 'Enviado com sucesso',
    txt_qsvbsylwmm: 'Defina uma senha com pelo menos 6 dígitos',
    txt_zhucerole: 'Registrar  No.{}',
    txt_qsrshh: 'Digite número do comerciante',
    txt_qsrdzh: 'Digite nome do gerente',
    txt_wsshhzl: 'Completer info da empersa',
    txt_wsdyhzl: 'Completer info do pessoal',
    txt_qsrshm: 'Digite nome do comerciante (nome da empersa)',
    txt_qsrshz: 'Digite dono (responsável)',
    txt_qsrzrqy: 'Por favor, entre na área de woring',
    txt_shanghudizhi: 'Endereço do comerciante',
    txt_yhycz: 'Usuário existe',
    txt_qsrzqdzh: 'Digite conta correta do gerente da loja',
    txt_qsrzqshh: 'Digite conta correta do comerciante',
    txt_xzmdcx: 'Escolhe consulta de loja',



    //门店
    txt_mendianId: 'ID da loja',
    txt_mendianmc: 'Nome da loja',
    txt_mendiandz: 'Endereço da loja',
    txt_mendiandh: 'TEL da loja',
    txt_caozuo: 'Operar',
    txt_mendiangl: 'Gestão da loja',
    txt_gjmendian: 'Total {0}',
    txt_zhengchangyy: 'Na operação',
    txt_tingye: 'For a da operação',
    txt_gengdxx: 'Mais',
    txt_dianygl: 'Empregados',
    txt_biangzt: 'Alterar estado',
    txt_qdygbzhuangtai: 'Tem certeza de que deseja alterar o estado da loja para {}?',
    txt_bjmendian: 'Editar informação da loja',
    txt_xinzenmd: 'Adicionar loja',
    txt_qtxmdmc: 'Por favor, preencha o nome da loja.',
    txt_qxzmddz: 'Selecione o endereço da loja',
    txt_qtxxdz: 'Endereço detalhe',
    txt_xiangxidz: 'Endereço detalhe',
    txt_qtxmddh: 'Preencha tel da loja',
    txt_dzxx: 'Informações do gerente',
    txt_chaungjianmendian: 'Preencha tel da loja',
    txt_mendianxxxx: 'Informações detalhadas',
    txt_bianji: 'Editar',
    txt_mendianzt: 'Estado da loja',

    //商户数据总览
    txt_mendianshuju: 'Armazenar dados',
    txt_chakangdxxbb: 'Confira mais relatórios',
    txt_jczcs: 'Inspeção total',
    txt_mdpjjc: 'Inspeção média',
    txt_jdzcl: 'Número acumulativo de veículos que entraram na loja',
    txt_jcl: 'Taxa de inspeção',
    txt_msqkjgtj: '磨损情况结果统计（轮胎条数）',
    txt_xyghltjgfb: '需更换轮胎的结果分布',
    txt_xzzyltjgfb: '需注意轮胎的结果分布',
    txt_sldwjgtj: '四轮定位结果统计（轮胎条数）',
    txt_xjxsldwfb: '需进行四轮定位轮胎的结果分布',
    txt_xzzyjxsldwfb: '需注意准备进行四轮定位轮胎的结果分布',
    txt_jrzl: 'Visão geral',
    txt_xiangqbb: 'Detalhes',
    txt_xuanzerqckxxsj: 'Selecione a data ',
    txt_qxzsjd: 'Escolhe hora',
    txt_sjdts: 'Você pode selecionar apenas um período inferior a 30 dias',
    txt_zonglan: 'Visão geral',
    txt_qushi: 'Tendênci',
    txt_shuliangtj: 'Estatísticas de quantidade',
    txt_syjcjgz: '所有检测结果中，各种磨损情况的轮胎条数及占比',
    txt_mslttsfb: '磨损轮胎条数分布情况',
    txt_msbgslzb: '(不同条数轮胎磨损的报告数量、以及在总检测数中的占比）',
    txt_sldwjlzb: '所有检测结果中，各种四轮定位结论的轮胎条数及占比',
    txt_sldwfbqk: '四轮定位结论条数分布情况',
    txt_btjgsldwzb: '不同条数四轮定位结论的报告数量、以及在总检测数中的占比',
    txt_jccsqs: "Tendência de inspeção Q'ty",
    txt_msqkslqs: 'Tendência do desgaste dos pneus',
    txt_jgfbqushi: '磨损轮胎需更换轮胎的结果分布趋势',
    txt_msltjgfbqs: '磨损轮胎需注意轮胎的结果分布趋势',
    txt_ltxsldwslqs: '轮胎需四轮定位情况数量趋势',
    txt_jccs: 'Número de veículos inspecionados',
    txt_shuliang: "Q'ty",
    txt_zhanbi: '%',
    txt_chankangd: 'Mais',
    txt_chakanmdxxbb: 'Detalhes',


    //国家
    txt_zhongguo: 'China',
    txt_mlxy: 'Malay',
    txt_yindu: 'Indian',
    txt_taiguo: 'Tailand',
    txt_oluosi: 'Russia',



    txt_taici: 'Um',
    txt_jianyi: 'Recomendação:',
    txt_jianyineirong: 'Há desgaste excêntrico no pneu, é recomendada UMA inspeção adicional',
    txt_jianyineirongzc: 'Normal',
    txt_bgtixing: 'Recordar:',
    txt_bgtuxubfnr: 'De acordo com o desgaste atual dos pneus, a distância de frenagem pode aumentar em {0}% (valor estimado)',
    txt_waishang: 'Trauma',
    txt_laohua: 'Envelhecimento',
    txt_gubao: 'Protuberância ',
    txt_xichemeirong: 'Beleza e lavagem de veículo',
    txt_weixiubaoyang: 'Reparo e manutenção',
    txt_guenghuanluntai: 'Substituição de pneu',
    txt_scsltjcy: 'Dispositivo de detecção de pneus portátil',
    txt_shijiantishi: 'A hora de término deve ser posterior à hora de início',

    txt_qxzclry: 'Selecione um manipuladorr',
    txt_lf_outworn: 'O lado externo do pneu dianteiro esquerdo está mais gasto do que o lado interno',
    txt_lf_innerworn: 'O lado interno do pneu dianteiro esquerdo está mais gasto do que o lado externo',
    txt_lf_bothsideworn: 'Os dois lados do pneu dianteiro esquerdo está mais gasto do que o meio',
    txt_lf_centreworn: 'O meio do pneu dianteiro esquerdo está mais gasto do que os dois lados',
    txt_lb_outworn: 'O meio do pneu dianteiro esquerdo está mais gasto do que os dois lados',       
    txt_lb_innerworn: 'O lado interno do pneu traseiro esquerdo está mais gasto do que o lado externo',        
    txt_lb_bothsideworn: 'Os dois lados do pneu traseiro esquerdo está mais gasto do que o meio',        
    txt_lb_centreworn: 'O meio do pneu traseiro esquerdo está mais gasto do que os dois lados',        
    txt_rb_outworn: 'O lado externo do pneu traseiro direito está mais gasto do que o lado interno',         
    txt_rb_innerworn: 'O lado interno do pneu traseiro direito está mais gasto do que o lado externo',        
    txt_rb_bothsideworn: 'Os dois lados do pneu traseiro direito está mais gasto do que o meio',         
    txt_rb_centreworn: 'O meio do pneu traseiro direito está mais gasto do que os dois lados',        
    txt_rf_outworn: 'O lado externo do pneu dianteiro dierito está mais gasto do que o lado interno',         
    txt_rf_innerworn: 'O lado interno do pneu dianteiro direito está mais gasto do que o lado externo',        
    txt_rf_bothsideworn: 'Os dois lados do pneu dianteiro direito está mais gasto do que o meio',       
    txt_rf_centreworn: 'O meio do pneu dianteiro direito está mais gasto do que os dois lados',  
    txt_tire_need_replace: 'Os pneus estão gastos e precisam ser substituídos imediatamente',

    txt_alignment_chassis: 'Recomenda-se alinhamento nas quatro rodas ou inspeção do chassi',

    txt_do_further_check: 'faça uma verificação adicional',
    txt_uneven_check: 'Se o pneu for usado de forma anormal, recomenda-se que se verifique o equilíbrio dinâmico, o alinhamento Das Quatro rodas e o sistema de suspensão',
    txt_tire_rotation: 'Recomenda-se rotação de pneu',           
    txt_wear_normal: 'Desgaste noral de pneus',   
    'txt_wear_normal;': 'Desgaste noral de pneus',     
    txt_tire: 'Pneu',
    txt_xiazai: 'Download',
    txt_xiazaishibai: 'Download falhou',
    txt_appname: 'Leadshub',
    txt_dianjixiazaiandroid: 'Baixar versão para Android',
    txt_dianjixiazaiios: 'Baixe a versão para iOS',






    txt_gelie: 'dividir',
    txt_diaokuai: 'Bloqueio caindo',
    txt_chaungci: 'perfuração',
    txt_cashang: 'scratch',
    txt_yichang: 'anormal',
    txt_qjybjcltazqk: 'Verifique a instalação do pneu Mais adiante',
    txt_wear_overall: 'Desgaste geral',
    txt_pattern_wear: 'Desgaste anormal',
    txt_tire_age: 'Vida útil de pneu',
    txt_tire_appearance: 'Aparência dos pneus',
    txt_tire_age_5:'O prazo de validade dos pneus ultrapassou 5 anos, recomenda-se substituir os pneus',
    txt_tire_age_3:'Os pneus foram usados por mais de 3 anos, verifique-os regularmente',
    txt_tire_age_8:'O prazo de validade dos pneus ultrapassou 8 anos, recomenda-se substituir os pneus',
    txt_tire_age_6:'Os pneus foram usados por mais de 6 anos, verifique-os regularmente',
    txt_tire_age_ok: 'Validade dos pneus está boa',
    txt_tire_trauma_check: 'Os pneus têm traumao, faça uma verificação adicional',
    txt_install_abnormal_check: 'Os pneus estão invertidos, confirme o tratamento',
    txt_tire_appearance_ok: 'Aparência boa dos pneus',
    txt_ltlcgstm: 'De acordo com o estado actual do desgaste DOS pneus, a Gama de pneus é {0} km (valor estimado)',
    'txt_tire_need_replace;': 'O pneu está muito gasto, recomenda-se substituir o pneu',
    'txt_uneven_check;': 'Se o pneu for utilizado de forma anormal, recomenda- se que se verifique o equilíbrio dinâmico, o alinhamento Das Quatro rodas e o sistema de suspensão',
    txt_tire_rotation: 'Recomenda-se rotação de pneu',
    'txt_tire_age_ok': 'Validade dos pneus está boa',
    'txt_wear_uniform;': 'Um único pneu se desgasta de maneira mais uniforme',    
    txt_wear_uniform: 'Um único pneu se desgasta de maneira mais uniforme',    
    'txt_tire_boundary;': 'Existem pneus estão gastos no estado limite',     
    txt_tire_boundary: 'Existem pneus estão gastos no estado limite', 
    txt_plcl: 'processamento EM lote',
    txt_qbxz: 'Seleccione tudo',
    txt_scjcjg: 'Resultado da última detecção',
    txt_ltxhlcgs: 'Estimativa da Gama de pneus',
    txt_ltazhuang: 'Instalação de pneus',
    txt_dqltlctx: 'O pneu actual atingiu o limite, por favor troque o pneu imediatamente',
    txt_dottx: 'Lembrete de vida útil do pneu',
    txt_danweinian: '(unidade: ano)',
    txt_danweikm: '(unidade: km)',
    txt_myhqdsj: 'Não obter tempo DOT',
    txt_dotjstx: 'De acordo com o tempo DOT, faltam {0} dias para o tempo de uso do pneu, verifique-o',
    txt_dotjstx2: 'O prazo de validade dos pneus ultrapassou 5 anos, recomenda-se substituir os pneus',
    txt_dotsjztx: 'DOT: Data de fabricação de pneu',
    'txt_tire_age_ok;': 'Validade dos pneus está boa',


    //微信公众号
    txt_mdmz: 'Nome da loja',
    txt_mddzz: 'Endereço da loja',
    txt_sbid: 'Dispositivo No.',
    txt_jsxm: 'Empregado',
    txt_shoujhm: 'telemóvel',
    txt_dxyzmm: 'Código de verificação por SMS',
    txt_jishimz: 'Técnico',
    txt_ltlcgsnew: 'A Gama de pneus é {0} km',
    txt_ltlcgsnewin: 'Tire range is {0} miles',
    txt_pinnate_wear: 'Desgaste pinnate',
    txt_msjxtx: 'O pneu atingiu o limite, por favor, substituí-lo imediatamente',
    txt_ltfz: 'Os pneus estão invertidos',
    txt_install_check: 'Verificação para instalação',
    txt_install_ok: 'Instalação de pneus normal',
    LF: '[Roda dianteira esquerda]',
    RF: '[Roda dianteira direita]',
    LB: '[Roda traseira direita]',
    RB: '[Roda traseira esquerda]',
    FF: '[Eixo dianteiro]',
    BB: '[Um eixo traseiro]',
    txt_appearance_check:'Existe traumao no pneu confirme o reparo',
    txt_uneven_center:'Desgaste anormal no meio do pneu, recomenda-se verificar a pressão do pneu',
    txt_uneven_out: 'O Lado externo do pneu é usado anormalmente. Recomenda- se que verifique o alinhamento Das Quatro rodas e a pressão DOS pneus',
    txt_pinnate_check: 'Os pneus apresentam desgaste pinnate. Recomenda-se verificar o alinhamento das quatro rodas e o sistema de suspensão',
    txt_uneven_inside: 'Se o Lado interno do pneu for usado anormalmente, recomenda- se que verifique o alinhamento Das Quatro rodas e a pressão DOS pneus',
    'txt_do_further_check;': 'faça uma verificação adicional',
    txt_uneven_bothside: 'Desgaste anormal EM Ambos OS lados do pneu. Recomenda- se verificar o alinhamento Das Quatro rodas e a pressão DOS pneus。',
    txt_msyzljgh: 'O pneu está muito gasto, recomenda-se substituir o pneu',
    txt_serious_trauma_check:"Existe traumao grave no pneu recomenda-se substituir pneu",
    txt_appearance_lookup:"Verifique aparência dos pneus",
    txt_wear_lookup :"Verifique desgaste dos pneus",
    txt_dotscsj: 'Data de fabricação de pneu',
    txt_whqdscsj: 'Não obter tempo DOT',
    purp_tireservice: 'Serviço de pneu',
    purp_vehicle_inspection: 'Inspecção do veículo',

    txt_qiao: 'Eixo',
    txt_left: 'Esquerda',
    txt_right: 'Direita',
    txt_lun: 'Pneu',
    txt_huawen: 'Padrão',
    txt_taihao: 'Penu No.',
    txt_taiya: 'Pressão do pneu',
    txt_chexlw: 'Modelo e posição de pneu',
    txt_jiancerenyuan: 'Pessoal de detecção',
    txt_beitai: 'Estepe',
    txt_tuoche: 'Trator',
    txt_guache: 'Reboque',
    txt_chassis_check: 'Verificação do chassi',
    txt_chassis_ok: 'Chassi é OK',
    txt_chassis_oil: 'O amortecedor vaza óleo, por favor, verifique mais',
    txt_chassis_aging: 'Envelhecimento da borracha da cabeça do eixo, recomenda-se o tratamento de substituição. ',
    txt_chassis_more: 'O chassi do veículo é anormal, por favor, faça uma verificação mais aprofundada',
    chassis_oil:'Absorvedores de choque vazam óleo',
    chassis_aging:'Envelhecimento da borracha da cabeça do eixo',
    chassis_normal:'Normal',
    
    txt_hood:'Tampa do motor',
    txt_wash_liquid:'Água do limpador',
    txt_level_control:' Controle de nível',
    txt_haoxiaoxi:'Normal',
    txt_vedi_Note:'Verificação manual ',
    txt_replace1:'Substituição',
    txt_radiator_fluid:'Fluido do radiador',
    txt_engine_oil:'Óleo do motor',
    txt_brake_fluid:'Fluido de freio',
    txt_quality_control:'Controle de qualidade',
    txt_multimeter:'Multímetro',
    txt_subtotal:'Quantidade',
    txt_shock_absorber:'Amortecedor',
    txt_check_loss:'Confira perdido',
    txt_brake_disc:' Disco de freio',
    txt_wear_condition:'Estado de desgaste',
    txt_brake_pads:'Pastilha de freio',
    txt_change_control:'Outro sistema de controle',
    txt_air_control:'Ar-condicionado',
    txt_last_reload:'Última vez carregando',
    txt_lighting:'Iluminação',
    txt_verification1:'Limpador',
    txt_dynamometer:'Dínamo',
    txt_batteria:'Bateria',
    txt_verification:'Executando a verificação',
    txt_levellow:'Normal',
    txt_levelmiddle:'Verificação manual',
    txt_levelhigh:'Substitui agora',
    txt_tyrenumber:'Profundidade de digitalização:',
    txt_cormach_title:'Desgaste geral & Desgaste excêntrico',
    txt_wearlow:'Desgaste uniforme do padrão',
    txt_wearmiddle:'Desgaste leve',
    txt_wearhigh:'Desgaste grave',
    txt_namtishi:'1/32nds',
    txt_trauma_eattyre:'Desgaste sério unvnen',
    txt_uneven_eattyre:'Pneu é desgaste irregular grave, por favor, verifique o sistema de suspensão',
    txt_appearance_eattyre:'Pneu é desgaste irregular grave, por favor, verifique o sistema de suspensão',
    txt_chassis_eattyre:'Pneu é desgaste irregular grave, por favor, verifique o sistema de suspensão',
    txt_uneven_high_eattyre:'Pneu é desgaste irregular grave, por favor, verifique o sistema de suspensão',
    txt_appearance_high_eattyre:'Pneu é desgaste irregular grave, por favor, verifique o sistema de suspensão',
    txt_chassis_high_eattyre:'Pneu é desgaste irregular grave, por favor, verifique o sistema de suspensão',
    txt_chassis_uneven:'Pneu é desgaste irregular grave, por favor, verifique o sistema de suspensão',
    txt_pianmoyichang:'Desgaste sério unvnen',
   
    txt_khxm:'Nome do cliente',
    txt_khyx:'e-mail do cliente',
}


// WEBPACK FOOTER //
// ./src/i18n/pt.js